const PageNotFound = () => {
  return (
    <div className="flex text-4xl bg-yellow-200 text-blue-500 text-bold justify-center items-center h-screen">
      <h1>Page Not Found.....</h1>
    </div>
  );
};

export default PageNotFound;
